import { getRelicDetail, getRelicPhoto } from '../../api/relic';
export const relic = {
  namespaced: true,
  namespace: 'relic',
  state: {
    relicDetail: ''
  },
  getters: {
    gettersRelicDetail: state => {
      return state.relicDetail;
    }
  },
  mutations: {
    setRelicDetail(state, relicDetail) {
      state.relicDetail = relicDetail;
    }
  },
  actions: {
    /**
     * 获取基本信息
     * @param {string} relicId 建筑id
     * @returns object
     */
    async getBaseRelicInfo({ commit }, relicId) {
      const {
        data: { data }
      } = await getRelicDetail(relicId);
      commit('setRelicDetail', data);
    },

    /**
     * 获取照片
     * @param {string} relicId
     */
    async getPhotoList({ commit }, relicId) {
      const {
        data: { data }
      } = await getRelicPhoto({
        page: 1,
        pageSize: 7,
        relicAutoIncrementId: relicId
      });
    }
  }
};
